import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FileBrowserService } from '../../../../../core/file-browser/file-browser.service';
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import { defer } from 'lodash';
import { UserService } from '../../../../../core/auth/_services/user.service';

@Component({
  selector: 'kt-file-browser-content',
  templateUrl: './file-browser-content.component.html',
  styleUrls: ['./file-browser-content.component.scss']
})
export class FileBrowserContentComponent implements OnInit {
  userList: any[];
  selectedUserList: any[];
  @Output() isCurrentSelectionOpened = new EventEmitter<boolean>();
  constructor(
    private readonly fileBrowserService: FileBrowserService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly layoutUtilsService: LayoutUtilsService,
    private readonly userService: UserService
  ) { }
  ngOnInit(): void {
    this.userService.getUsersByFilters({fields: 'name'}, null, true).subscribe((data: any) => {
      if(data.status === 200) {
        this.userList = [...data.data];
      }
    })
  }

  get flatTransformedData() {
    return this.fileBrowserService.flatTransformedData;
  }

  get prevSelectedFileFolder() {
    return this.fileBrowserService.prevSelectedFileFolder;
  }

  set prevSelectedFileFolder(data: any) {
    this.fileBrowserService.prevSelectedFileFolder = data;
  }
  get currentSelectedFolderPathInfo() {
    return this.fileBrowserService.currentSelectedFolderPathInfo;
  }

  set currentSelectedFolderPathInfo(value: any) {
    this.fileBrowserService.currentSelectedFolderPathInfo = value;
  }

  get folderName() {
    return this.fileBrowserService.folderName
  }

  set folderName(value: string) {
    this.fileBrowserService.folderName = value;
  }

  get duplicateFolderNamePresent() {
    return this.fileBrowserService.duplicateFolderNamePresent
  }

  set duplicateFolderNamePresent(value: boolean) {
    this.fileBrowserService.duplicateFolderNamePresent = value;
  }

  indentationOfNestedEle(index: number) {
    return {
      'padding-left': `${this.flatTransformedData[index].level * 19}px`,
    }
  }

  toggleNestedData(index: number) {
    if (this.flatTransformedData[index]?.isTemporary) return; // Function call is stopped for new folder creation
    this.clearTempFolderOnNavigation()
    const isOpened = this.flatTransformedData[index].isOpened;
    const currPath = this.flatTransformedData[index].currentPath;
    this.currentSelectedFolderPathInfo = { path: currPath, index };
    // this.updateCurrentSelection(index)
    if (isOpened) {
      const currLevel = this.flatTransformedData[index].level;
      let idx = index + 1;
      while (idx < this.flatTransformedData.length && this.flatTransformedData[idx].level > currLevel) {
        idx++;
      }
      this.flatTransformedData.splice(index + 1, idx - index - 1);
      this.flatTransformedData[index].isOpened = false;
      this.isCurrentSelectionOpened.emit(false)
      this._changeDetectorRef.detectChanges();
    }
    else {
      this.fileBrowserService.getFilesAndFolders(currPath).subscribe(response => {
        this.fileBrowserService.transformObjectDataIntoFlatTree(response.data, index);
        this.flatTransformedData[index].isOpened = true;
        this.isCurrentSelectionOpened.emit(true)
        this._changeDetectorRef.detectChanges();
      });
    }
  }

  highlightCurrentSelection(index){
    if (this.flatTransformedData[index]?.isTemporary) return;
    this.clearTempFolderOnNavigation()
    this.currentSelectedFolderPathInfo = { path: this.flatTransformedData[index].currentPath, index };
    this.updateCurrentSelection(index)
  }

  openFile(index: number) {
    const currentFilePath: string = this.flatTransformedData[index].currentPath;
    if (!currentFilePath) return;
    this.clearTempFolderOnNavigation();
    const lastIndex = currentFilePath.lastIndexOf('/');
    const currentFolderPath = currentFilePath.slice(0, lastIndex + 1);
    const folderIndex = this.flatTransformedData.findIndex(data => data.currentPath === currentFolderPath)
    this.currentSelectedFolderPathInfo = { path: currentFolderPath, index: folderIndex };
    this.updateCurrentSelection(index);
    this.fileBrowserService.openFileInNewTab(this.flatTransformedData[index].url);
  }

  updateCurrentSelection(index: number) {
    if (this.flatTransformedData[index].isSelected) return;
    this.flatTransformedData[index].isSelected = true;
    if (this.prevSelectedFileFolder !== null && this.prevSelectedFileFolder !== this.flatTransformedData[index]) {
      this.prevSelectedFileFolder.isSelected = false;
    }
    this.prevSelectedFileFolder = this.flatTransformedData[index];
  }

  clearTempFolderOnNavigation() {
    const tempFolderData = this.flatTransformedData[this.currentSelectedFolderPathInfo.index];
    if (tempFolderData?.isTemporary) {
      this.flatTransformedData.splice(this.currentSelectedFolderPathInfo.index, 1);
    }
  }

  createNewFolder(index: number) {
    if (!this.folderName.length || this.duplicateFolderNamePresent) return;
    let folderName: string = this.folderName + '/';
    this.fileBrowserService.createFolder(folderName, this.prevSelectedFileFolder.currentPath).subscribe((data) => {
      this.layoutUtilsService.showActionNotification(`${this.folderName} created successfully.`);
      this.flatTransformedData.splice(index, 1);
      this.fileBrowserService.getFilesAndFolders(this.prevSelectedFileFolder.currentPath).subscribe(response => {
        this.fileBrowserService.transformObjectDataIntoFlatTree(response.data, this.currentSelectedFolderPathInfo.index - 1);
        this.folderName = '';
        this._changeDetectorRef.detectChanges();
      });
    },
      error => {
        this.layoutUtilsService.showActionNotification(`${this.folderName} didn't created successfully.`);
      })
  }

  cancelCreateNewFolder(index: number) {
    this.flatTransformedData.splice(index, 1);
    this.fileBrowserService.prevSelectedFileFolder = null;
    this.currentSelectedFolderPathInfo = {
      path: '',
      index: null
    };
    this.folderName = '';
    this._changeDetectorRef.detectChanges();
  }

  validateFolderNameDuplicate() {
    this.duplicateFolderNamePresent = false;
    for (let idx = this.currentSelectedFolderPathInfo.index + 1; idx < this.flatTransformedData.length; idx++) {
      if (this.flatTransformedData[idx].level != this.prevSelectedFileFolder.level + 1) break;
      if (this.flatTransformedData[idx].name === this.folderName && this.flatTransformedData[idx].type == 'folder') this.duplicateFolderNamePresent = true;
    }
  }

  onMouseHoverForDeleteAndEdit(event: any, filePath: string, index: number) {
    event.stopPropagation();
    defer(() => {
      const currFileObject = this.flatTransformedData[index];
      currFileObject['showIcon'] = true
      this._changeDetectorRef.detectChanges();
      if (currFileObject['canDeleteEdit'] == undefined && !this.flatTransformedData[index].incompleteFile && !this.flatTransformedData[index].uploadFailed) {
        // Fetch metadata to check whether current user is the owner of the file
        if (this.userService.getUserFromLocalStorage().admin) {
          currFileObject['canDeleteEdit'] = true;
          this._changeDetectorRef.detectChanges();
          return;
        }
        this.fileBrowserService.getMetaDataOfTheFile(filePath).subscribe((res: any) => {
          if(res.data && (res.data['x-user-id'] || res.data['x_user_id'])){
            const fileUserId = res.data['x-user-id'] || res.data['x_user_id'];
            if (fileUserId == this.userService.getUserFromLocalStorage()._id) {
              currFileObject['canDeleteEdit'] = true;
            }
            else {
              currFileObject['canDeleteEdit'] = false;
            }
          }
          else{
            currFileObject['canDeleteEdit'] = false;
          }
          this._changeDetectorRef.detectChanges();
        });
      }
    })
  }

  editName(event: any, filePath: string, index: number) {
    event.stopPropagation();
    this.flatTransformedData[index]["renamingFile"] = true;
    const { name } = this.fileBrowserService.getFileNameAndExtension(this.flatTransformedData[index].name)
    this.flatTransformedData[index]["temporaryName"] = name;
    this.flatTransformedData[index].duplicateFileName = false;
    this._changeDetectorRef.detectChanges();
  }

  renameFile(event: any, index: number) {
    event.stopPropagation();
    const temporaryName = this.flatTransformedData[index].temporaryName;
    if (!temporaryName || temporaryName.length == 0 || this.flatTransformedData[index].duplicateFileName || this.fileBrowserService.getFileNameAndExtension(this.flatTransformedData[index].name).name == temporaryName) {
      return;
    }
    let currPath = String(this.flatTransformedData[index].currentPath);
    const lastIndexOfPath = currPath.lastIndexOf('/');
    const folderPath = currPath.slice(0, lastIndexOfPath + 1)
    this.flatTransformedData[index].duplicateFileName = false;
    const { extension } = this.fileBrowserService.getFileNameAndExtension(this.flatTransformedData[index].name)
    let newPath = folderPath.concat(temporaryName, `.${extension}`);
    this.fileBrowserService.renameFile(currPath, newPath).subscribe(() => {
      this.fileBrowserService.getFilesAndFolders(folderPath).subscribe(response => {
        let data = response.data;
        for (let key of Object.keys(data)) {
          if (this.flatTransformedData.find(ele => ele['currentPath'] === key)) {
            delete data[key];
          }
        }
        Object.keys(data).forEach(key => {
          this.flatTransformedData[index].url = data[key].url;
          this.flatTransformedData[index].lastModified = data[key].lastModified;
          this.flatTransformedData[index].name = temporaryName.concat(`.${extension}`);
          this.flatTransformedData[index].currentPath = folderPath + this.flatTransformedData[index].name;
          delete this.flatTransformedData[index].temporaryName;
          delete this.flatTransformedData[index].renamingFile;
          this._changeDetectorRef.detectChanges();
        })
      })
    })
  }

  validateFileNameDuplicate(index: number) {
    this.flatTransformedData[index]['duplicateFileName'] = false;
    const fileLevel = this.flatTransformedData[index].level;
    const fileName = this.flatTransformedData[index].temporaryName;
    const { extension } = this.fileBrowserService.getFileNameAndExtension(this.flatTransformedData[index].name)
    let startIndexOfCurrentDirectory = index
    while (fileLevel <= this.flatTransformedData[startIndexOfCurrentDirectory].level) {
      startIndexOfCurrentDirectory--;
    }
    for (let i = startIndexOfCurrentDirectory + 1; i < this.flatTransformedData.length; i++) {
      const { name: currentFileName, extension: currentFileExtension } = this.fileBrowserService.getFileNameAndExtension(this.flatTransformedData[i].name)
      if (fileLevel > this.flatTransformedData[i].level) break;
      else if (fileLevel != this.flatTransformedData[i].level || i == index) continue;
      else if (fileLevel === this.flatTransformedData[i].level && fileName == currentFileName && extension == currentFileExtension && this.flatTransformedData[i].type == 'file') {
        this.flatTransformedData[index]['duplicateFileName'] = true;
      }
    }

  }

  cancelRename(event: any, index: number) {
    event.stopPropagation();
    this.flatTransformedData[index].duplicateFileName = false;
    delete this.flatTransformedData[index].renamingFile;
    delete this.flatTransformedData[index].temporaryName;
    this._changeDetectorRef.detectChanges();
  }

  deleteFile(event: any, filePath: string, index: number) {
    event.stopPropagation();
    this.fileBrowserService.deleteFile(filePath).subscribe(() => {
      if (this.flatTransformedData[index].isSelected) {
        this.fileBrowserService.goBackToPreviousSelectedFolder();
      }
      this.flatTransformedData.splice(index, 1);
      const newIndexOfSelectedFolderPath = this.flatTransformedData.findIndex(data => data.currentPath == this.currentSelectedFolderPathInfo.path);
      if (newIndexOfSelectedFolderPath >= 0) {
        this.currentSelectedFolderPathInfo.index = newIndexOfSelectedFolderPath;
      }
      this._changeDetectorRef.detectChanges();
    })
  }
}
